import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SingleSelect from '../../common/Forms/SingleSelect';

const RailsSingleSelect = ({ options, selectedValue, inputName, placeholder, setWidth = true, elementId }) => {
  const [selectedOption, setSelectedOption] = useState(selectedValue);

  const handleChange = (option) => {
    setSelectedOption(option);
  };

  return (
    <div style={ { width: setWidth ? '500px' : '100%' } }>
      <input name={inputName}
             id={elementId}
             value={selectedOption && selectedOption.value || ''}
             hidden/>
      <SingleSelect
        handleChange={handleChange}
        options={options}
        selectedValue={selectedOption}
        placeholderText={placeholder}
      />
    </div>
  );
};

RailsSingleSelect.propTypes = {
  options: PropTypes.array,
  selectedValues: PropTypes.array
};

RailsSingleSelect.defaultProps = {
  options: [{}],
  selectedValues: [{}]
};

export default RailsSingleSelect;
